import { clsxMerge } from "shared/lib/helpers";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

export const VerticalDivider = ({ className }: PropsWithClassNameI) => (
  <div
    className={clsxMerge("h-[34px] w-[2px] rounded-lg bg-[#D9D9D9]", className)}
  />
);
